import React, { Component, PropTypes } from 'react';
import { SparkSelectInput } from '../ui/spark';
import classnames from 'classnames';

/**
 * @deprecated use <ControlledSelect/> from sabre-spark-react-ex or <Select/> from sabre-spark-react
 */
class ReactSparkSelectInput extends Component {
    componentDidMount() {
        this.selectInput = new SparkSelectInput(this.selectInputMount);
    }

    render() {
        const labelClassName = classnames('spark-select', {
            'has-value': !!this.props.defaultValue
        });
        return (
            <div className={this.props.className}>
                <label
                    className={labelClassName}
                    ref={node => (this.selectInputMount = node)}
                    style={{ display: 'block' }}
                >
                    <select
                        disabled={this.props.isDisabled}
                        className="spark-select__input"
                        defaultValue={this.props.defaultValue}
                        onChange={this.props.onChange}
                        value={this.props.defaultValue}
                    >
                        {this.props.values.map(value => {
                            return (
                                <option value={value.key} key={value.key}>
                                    {value.label}
                                </option>
                            );
                        })}
                    </select>
                    <span className="spark-label">{this.props.label}</span>
                </label>
            </div>
        );
    }
}

ReactSparkSelectInput.propTypes = {
    label: PropTypes.string,
    values: PropTypes.array,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool
};

ReactSparkSelectInput.defaultProps = {
    isDisabled: false
};

export default ReactSparkSelectInput;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkSelectInput.js